import { DocumentNode, gql } from "@apollo/client";

class PersonaToolingService {
  public static listPersonas = (): DocumentNode => gql`
    query ListPersonas {
      listPersonas {
        id
        testTypes
        orderCount
        comment
      }
    }
  `;

  public static activatePersona = (): DocumentNode => gql`
    mutation ActivatePersona($personaId: String!) {
      activatePersona(personaId: $personaId) {
        success
        orderCount
        message
      }
    }
  `;

  public static injectPersona = (): DocumentNode => gql`
    mutation InjectPersona($payload: String!) {
      injectPersona(payload: $payload) {
        success
        orderCount
        message
      }
    }
  `;

  public static clearInjectedPersonas = (): DocumentNode => gql`
    mutation ClearInjectedPersonas {
      clearInjectedPersonas {
        success
        orderCount
        message
      }
    }
  `;
}

export default PersonaToolingService;
